import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _omitBy from "lodash/omitBy";
import _get from "lodash/get";
import _clone from "lodash/clone";
import { Tracking as NWTracking } from '@nerdwallet/nw-client-lib';
export default (function (eventName) {
  var trackingState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var flow = arguments.length > 3 ? arguments[3] : undefined;

  var trk = _clone(_get(trackingState, 'trk', {}));

  if (flow) trk.trk_flow = flow;

  var amplitudeOnlyTrk = _get(trackingState, 'amplitudeOnlyTrk', {});

  var appName = trackingState.appName;

  var eventData = _omitBy(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    formName: eventName,
    appName: appName,
    fieldName: eventName
  }, data), amplitudeOnlyTrk), trk), {}, {
    // additional data should contain all additional data we send to amplitude minus trk params
    additionalData: JSON.stringify(_objectSpread(_objectSpread({}, data), trk))
  }), function (val) {
    return !val;
  });

  NWTracking.formInputChanged(eventData);
});